import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, indexedDBLocalPersistence, initializeAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCQw1plg9WCBveFJf9892YZC6FfXQUqnKc",
  authDomain: "tuttoclarov2.firebaseapp.com",
  projectId: "tuttoclarov2",
  storageBucket: "tuttoclarov2.firebasestorage.app",
  messagingSenderId: "703756924772",
  appId: "1:703756924772:web:b43edad45dfd52fa5c2c71"
};

const app = initializeApp(firebaseConfig);
const isNative = window.Capacitor?.isNativePlatform?.() || false;
export const auth = isNative
  ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
  : getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
export default app;
